import { borderBottom } from "@material-ui/system";

/* Response Time CSS */

export default theme => ({
    rootClassName:{
        width:"100%"
    },
    snackContent: {
        backgroundColor: theme.palette.error.dark,
      },
      snackContentOk: {
        backgroundColor: theme.palette.success.main,
      },
      message: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 15,
      },
      icon: {
        fontSize: 20,
      },
      iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(2),
      },
});

